export var TelemetryPlatform;
(function (TelemetryPlatform) {
    TelemetryPlatform["WIN"] = "Windows";
    TelemetryPlatform["LIN"] = "Linux";
    TelemetryPlatform["MACOS"] = "MacOS";
    TelemetryPlatform["IOS"] = "IOS";
    TelemetryPlatform["ANDROID"] = "Android";
    TelemetryPlatform["OTHER"] = "Other";
})(TelemetryPlatform || (TelemetryPlatform = {}));
export var Component;
(function (Component) {
    Component["DESKTOP_CLIENT"] = "DesktopClient";
    Component["DAEMON"] = "Daemon";
    Component["HUB"] = "Hub";
    Component["WEB_SERVICE"] = "WebService";
    Component["WEB_CLIENT"] = "WebClient";
    Component["MOBILE_CLIENT"] = "MobileClient";
    Component["SDK"] = "LucidSdk";
    Component["API"] = "LucidApi";
    Component["FS_UPGRADE"] = "FsUpgrade";
    Component["PYTHON_SDK"] = "LucidPythonSDK";
})(Component || (Component = {}));
export var DaemonEventSource;
(function (DaemonEventSource) {
    DaemonEventSource["CLI"] = "Cli";
    DaemonEventSource["DESKTOP_CLIENT"] = "DesktopClient";
    DaemonEventSource["DIRECT_REST"] = "DirectRest";
})(DaemonEventSource || (DaemonEventSource = {}));
